module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic-VariableFont.87a9f36.ttf";